import React from 'react';

import { Box } from '@mui/material';

import EmployersList from './employers_list';
import PageHeader from '../../common/page_header';

const EmployersPage = () => {
    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>
            <PageHeader title="Pracodawcy"/>

            <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
                <EmployersList/>
            </Box>
        </Box>
    );
};

export default EmployersPage;